import React from "react";
import {
  StyledFormElementsWrapper,
  ContainerGrid,
  FormLabel,
  Subheading,
} from "../styles";
import FormField from "../../../common/FormField/FormField";
import { CustomFileUpload } from "../../../common/FormInputs";
import CustomSelect from "./CustomSelect";
import {
  Grid,
  Radio,
  RadioGroup,
  makeStyles,
  FormControlLabel,
} from "@material-ui/core";

const useStyles = makeStyles((themes) => ({
  formLabel: {
    fontFamily: "openSans-SemiBold, sans-serif",
    color: "#293461",
  },
}));

const GenerateNotice = ({
  values,
  handleChange,
  errors,
  touched,
  handleBlur,
  setFieldValue,
  s3Upload,
  getFileName,
  menuItems,
  menuNotice,
  menuTemplateCode,
  menuHeaderFooter,
  getNoticeTemplates,
  cmId,
  radioInputs,
}) => {
  const classes = useStyles();

  let excelTemplate =
    menuTemplateCode[values?.noticeCategory]?.length &&
    menuTemplateCode[values?.noticeCategory]?.filter(
      (template) => template?.templateCode === values?.templateCode,
    )[0]?.excelTemplate;

  const inputs = [
    {
      type: "select",
      name: "noticeCategory",
      label: "Notice Category",
      required: true,
      items: menuNotice,
    },
    {
      type: "select",
      name: "templateCode",
      label: "Template Code",
      required: true,
      items: menuTemplateCode[values?.noticeCategory]?.length
        ? menuTemplateCode[values?.noticeCategory]?.map(
            ({ id, templateCode }) => ({
              id: id,
              label: templateCode,
              value: templateCode,
            }),
          )
        : [],
    },
    {
      type: "select",
      name: "noticeCopyDesign",
      label: "Notice Copy Design",
      required: true,
      items: menuItems?.filter((party) => party?.value === values?.partyId)
        ?.length
        ? menuItems
            ?.filter((party) => party?.value === values?.partyId)
            .map((item) => [
              { label: "Default design", value: "default" },
              { label: item.label, value: item.label },
            ])[0]
        : [{ label: "Default design", value: "default" }],
    },
    {
      type: "number",
      name: "lotNo",
      label: "Lot Number",
      required: true,
    },
    {
      type: "text",
      name: "codeType",
      label: "Code Type",
      required: false,
    },
    {
      type: "text",
      name: "arbitratorName",
      label: "Arbitrator Name",
      required: false,
    },
    {
      type: "text",
      name: "institutionName",
      label: "Institution Name",
      required: false,
    },
    {
      type: "select",
      name: "loanType",
      label: "Loan Type",
      required: false,
      items: [
        { label: "Vehicle Loan", value: "vehicleLoan" },
        { label: "Business Loan", value: "businessLoan" },
        { label: "Personal Loan", value: "personalLoan" },
      ],
    },
    {
      type: "select",
      name: "loanStatus",
      label: "Loan Status",
      required: false,
      items: [
        { label: "Matured", value: "matured" },
        { label: "Short Fall", value: "shortFall" },
        { label: "Running", value: "running" },
      ],
    },
  ];

  const upload_templates = [
    {
      name: "excelFile",
      label: "Upload Excel Template (xlsx)",
      type: "upload",
      required: true,
      accept: ".xlsx",
      types: [
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        "application/vnd.ms-excel",
        "text/csv",
      ],
      downloadType: "Please download the xlsx template",
      url: excelTemplate,
    },
  ];

  const input_alignments = [
    { label: "Left", value: 1 },
    { label: "Right", value: 3 },
    { label: "Center", value: 2 },
  ];

  return (
    <>
      <StyledFormElementsWrapper style={{ marginBottom: 8, marginTop: 15 }}>
        <ContainerGrid className="disabledArrows">
          <CustomSelect
            name="partyId"
            trigger={true}
            {...{
              errors,
              touched,
              setFieldValue,
              menuItems,
              getNoticeTemplates,
            }}
          />
          {/* <FormField
            white
            input={{
              type: "select",
              name: "partyId",
              label: "Select a Party",
              required: true,
            }}
            showId
            menuItems={menuItems}
            {...{
              values,
              errors,
              touched,
              handleBlur,
              setFieldValue,
            }}
            handleChange={(e) => getNoticeTemplates(e?.target?.value)}
          /> */}
          {inputs.map((input, index) => {
            return (
              <FormField
                key={index}
                menuItems={input.items}
                {...{
                  touched,
                  errors,
                  input,
                  values,
                  handleChange,
                  handleBlur,
                  setFieldValue,
                }}
              />
            );
          })}
          {upload_templates.map((upload, index) => (
            <div style={{ marginTop: 10 }}>
              <FormLabel>
                {upload.label} <span className="required-star"> *</span>
              </FormLabel>
              <CustomFileUpload
                error={touched[upload.name] && errors[upload.name]}
                setFile={(file) =>
                  s3Upload(file, upload.name, setFieldValue, upload.types)
                }
                style={{
                  width: "100%",
                }}
                accept={upload.accept}
                file={{ name: getFileName(values[upload.name]) }}
              />
              {upload.url?.length && (
                <Subheading>
                  <a
                    target="_blank"
                    rel="noopener noreferrer"
                    href={upload.url}
                  >
                    {upload.downloadType}
                  </a>
                </Subheading>
              )}
            </div>
          ))}
          {/* {[
            {
              type: "select",
              name: "checkerId",
              label: "Select a checker",
              required: false,
            },
          ].map((input, index) => {
            return (
              <FormField
                key={index}
                menuItems={cmList.filter((item) => item?.value !== cmId)}
                {...{
                  touched,
                  errors,
                  input,
                  values,
                  handleChange,
                  handleBlur,
                  setFieldValue,
                }}
              />
            );
          })} */}
        </ContainerGrid>
        <Grid
          className={classes.radioRoot}
          item
          xs={12}
          spacing={2}
          style={{ marginBottom: "5px" }}
        >
          <RadioGroup
            style={{
              flexDirection: "row",
              marginLeft: "10px",
            }}
            name={"typeOfLetterHead"}
            value={values.typeOfLetterHead}
            onChange={(e) => {
              setFieldValue("typeOfLetterHead", e.target.value);
            }}
          >
            {radioInputs.map((radio, key) => (
              <FormControlLabel
                {...{ key }}
                classes={{ label: classes.formLabel }}
                value={radio.value}
                control={<Radio size="medium" style={{ color: "#00838c" }} />}
                label={radio.label}
              />
            ))}
          </RadioGroup>
        </Grid>
        <ContainerGrid>
          {[
            {
              type: "select",
              name: "letterHeadName",
              label: "Letter Head Name",
              required: false,
              items: menuHeaderFooter,
            },
          ].map((input, index) => {
            return (
              <FormField
                key={index}
                menuItems={input.items}
                {...{
                  touched,
                  errors,
                  input,
                  values,
                  handleChange,
                  handleBlur,
                  setFieldValue,
                }}
              />
            );
          })}
          {values?.typeOfLetterHead === "text"
            ? [
                {
                  type: "select",
                  name: "headerAlignment",
                  label: "Header Alignment",
                  required: false,
                  items: input_alignments,
                },
                {
                  type: "select",
                  name: "footerAlignment",
                  label: "Footer Alignment",
                  required: false,
                  items: input_alignments,
                },
              ].map((input, index) => {
                return (
                  <FormField
                    key={index}
                    menuItems={input.items}
                    {...{
                      touched,
                      errors,
                      input,
                      values,
                      handleChange,
                      handleBlur,
                      setFieldValue,
                    }}
                  />
                );
              })
            : null}
        </ContainerGrid>
      </StyledFormElementsWrapper>
    </>
  );
};

export default GenerateNotice;
